(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-avm"]) return;
  try {
    
(function () {
  'use strict';

  if (customElements.get('avm-cart-drawer')) return;

  class AvmCartDrawer extends HTMLElement {
    constructor() {
      super();
      this._activeElement = null;
      this._isOpen = false;
      this._cartUpdateUnsubscribe = null;
      this._pubsubReadyHandler = null;

      this._overlay  = this.querySelector('#avm-cart-overlay');
      this._panel    = this.querySelector('#avm-cart-panel');
      this._closeBtn = this.querySelector('#avm-drawer-close-btn');

      if (this._overlay)  this._overlay.addEventListener('click', () => this.close());
      if (this._closeBtn) this._closeBtn.addEventListener('click', () => this.close());

      this.addEventListener('keydown', (e) => this._handleKeydown(e));

      this._bindCartIcon();
      this._subscribeToCraftPubsub();
      this._bindCheckoutGuard();
    }

    /* ── Cart icon binding ── */
    _bindCartIcon() {
      var cartIcon = document.querySelector('#cart-icon-bubble');
      if (!cartIcon) return;
      cartIcon.setAttribute('role', 'button');
      cartIcon.setAttribute('aria-haspopup', 'dialog');
      cartIcon.setAttribute('aria-controls', 'avm-cart-panel');
      cartIcon.setAttribute('aria-expanded', 'false');
      cartIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(cartIcon);
      });
      cartIcon.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); this.open(cartIcon); }
      });
    }

    /* ── Subscribe to Craft pubsub cart events ── */
    _subscribeToCraftPubsub() {
      if (this._cartUpdateUnsubscribe) return;

      /* This section can initialize before Craft's deferred pubsub.js. */
      if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
        if (!this._pubsubReadyHandler) {
          this._pubsubReadyHandler = () => {
            this._pubsubReadyHandler = null;
            this._subscribeToCraftPubsub();
          };
          document.addEventListener('DOMContentLoaded', this._pubsubReadyHandler, { once: true });
        }
        return;
      }

      this._cartUpdateUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        /* Ignore updates that originate from this drawer to avoid loops */
        if (event && event.source === 'avm-cart-drawer') return;
        this.refreshSection()
          .then(() => this.open())
          .catch(() => this._showError());
      });
    }

    /* ── All focusable elements within the panel ── */
    _getFocusable() {
      var nodes = this._panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), ' +
        '[tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.slice.call(nodes).filter(function (el) {
        var style = getComputedStyle(el);
        return (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          !el.closest('[hidden]')
        );
      });
    }

    /* ── Focus trap (WCAG 2.1 §2.1.2 No Keyboard Trap is satisfied by Esc) ── */
    _handleKeydown(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab' || !this._isOpen) return;

      var focusable = this._getFocusable();
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last  = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    /* ── Open ── */
    open(trigger) {
      if (trigger) {
        this._activeElement = trigger;
      } else if (!this._isOpen && document.activeElement instanceof HTMLElement) {
        this._activeElement = document.activeElement;
      }
      this._isOpen = true;
      this.classList.add('avm-drawer--open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('avm-drawer-open');
      document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(() => {
        var focusable = this._getFocusable();
        var target = this._closeBtn || focusable[0];
        if (target) target.focus();
      });
    }

    /* ── Close ── */
    close() {
      var returnTarget = this._activeElement;
      this._activeElement = null;
      if (returnTarget && returnTarget.isConnected) returnTarget.focus();

      this._isOpen = false;
      this.classList.remove('avm-drawer--open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('avm-drawer-open');
      document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'false');
    }

    _setLoading(loading) {
      if (loading) this.setAttribute('loading', '');
      else this.removeAttribute('loading');
    }

    _bindCheckoutGuard() {
      var form = this.querySelector('.avm-drawer__checkout-form');
      var btn = this.querySelector('#avm-checkout-btn');
      if (!form || !btn) return;
      if (form.dataset.avmCheckoutGuardBound === 'true') return;
      form.dataset.avmCheckoutGuardBound = 'true';
      form.addEventListener('submit', function () {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-loading');
      });
    }

    /* ── Quantity change: POST /cart/change.js then re-render ── */
    async changeQuantity(key, quantity) {
      this._setLoading(true);
      try {
        var res = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        if (!res.ok) throw new Error('Cart change failed: ' + res.status);
        await this.refreshSection();
        this._publishCartUpdate();
      } catch (err) {
        this._showError();
      } finally {
        this._setLoading(false);
      }
    }

    _showError() {
      var host = this.querySelector('#avm-cart-items');
      if (!host) return;
      var msg = document.createElement('p');
      msg.style.cssText = 'color:#c0392b;font-size:1.2rem;padding:1rem 2rem;';
      msg.setAttribute('role', 'alert');
      msg.textContent = window.cartStrings ? window.cartStrings.error : 'Something went wrong. Please try again.';
      host.prepend(msg);
      setTimeout(function () { msg.remove(); }, 4000);
    }

    _publishCartUpdate() {
      if (typeof publish === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'avm-cart-drawer' });
    }

    /* ── Fetch re-rendered section HTML from Shopify Sections API ── */
    async refreshSection() {
      try {
        var res = await fetch('/?sections=cart-drawer-avm');
        if (!res.ok) throw new Error('Section fetch failed');
        var data = await res.json();
        var html = data['cart-drawer-avm'];
        if (!html) throw new Error('Cart drawer section was missing from the response');

        var freshDoc = new DOMParser().parseFromString(html, 'text/html');

        var selectors = [
          '#avm-cart-items',
          '#avm-cart-footer',
          '#avm-shipping-bar',
          '#avm-fbt-section',
          '#avm-cart-count',
        ];

        selectors.forEach((sel) => {
          var target = this.querySelector(sel);
          var source = freshDoc.querySelector(sel);
          if (target && source) {
            target.replaceWith(source.cloneNode(true));
          } else if (target && !source) {
            /* Element removed in fresh render (e.g. FBT or count gone) */
            target.remove();
          } else if (!target && source) {
            var clone = source.cloneNode(true);
            var body = this.querySelector('#avm-drawer-body');

            if (sel === '#avm-fbt-section' && body) {
              body.appendChild(clone);
            } else if (sel === '#avm-cart-footer' && body) {
              body.insertAdjacentElement('afterend', clone);
            } else if (sel === '#avm-cart-count') {
              var heading = this.querySelector('.avm-drawer__heading');
              if (heading) heading.appendChild(clone);
            } else if (sel === '#avm-shipping-bar') {
              var header = this.querySelector('.avm-drawer__header');
              if (header) header.insertAdjacentElement('afterend', clone);
            }
          }
        });

        this._syncCartCount(freshDoc);
        this._bindItemControls();
        this._bindCheckoutGuard();
      } catch (err) {
        throw err;
      }
    }

    _syncCartCount(freshDoc) {
      var freshCount = freshDoc.querySelector('#avm-cart-count');
      var count = freshCount ? parseInt(freshCount.textContent.replace(/\D/g, ''), 10) || 0 : 0;
      var cartIcon = document.querySelector('#cart-icon-bubble');
      var bubble = cartIcon ? cartIcon.querySelector('.cart-count-bubble') : null;

      if (count > 0 && cartIcon) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartIcon.appendChild(bubble);
        }

        var visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        var accessibleCount = bubble.querySelector('.visually-hidden');
        if (visibleCount) visibleCount.textContent = count < 100 ? count : '99+';
        if (accessibleCount) accessibleCount.textContent = count + (count === 1 ? ' item' : ' items');
      } else if (bubble) {
        bubble.remove();
      }

      document.querySelectorAll('[data-avm-mobile-cart-count]').forEach(function (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    }

    /* ── Bind per-item quantity / remove controls ── */
    _bindItemControls() {
      var self = this;

      this.querySelectorAll('[data-action="decrease"]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var key = e.currentTarget.dataset.key;
          var input = self.querySelector('input.avm-qty__input[data-key="' + key + '"]');
          var qty = input ? parseInt(input.value, 10) : 1;
          self.changeQuantity(key, Math.max(0, qty - 1));
        });
      });

      this.querySelectorAll('[data-action="increase"]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var key = e.currentTarget.dataset.key;
          var input = self.querySelector('input.avm-qty__input[data-key="' + key + '"]');
          var qty = input ? parseInt(input.value, 10) : 1;
          self.changeQuantity(key, qty + 1);
        });
      });

      this.querySelectorAll('[data-action="remove"]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          self.changeQuantity(e.currentTarget.dataset.key, 0);
        });
      });

      this.querySelectorAll('input.avm-qty__input').forEach(function (input) {
        var debounceTimer;
        input.addEventListener('change', function (e) {
          clearTimeout(debounceTimer);
          var key = e.currentTarget.dataset.key;
          var qty = Math.max(0, parseInt(e.currentTarget.value, 10) || 0);
          debounceTimer = setTimeout(function () { self.changeQuantity(key, qty); }, 400);
        });
      });
    }

    /* ── FBT quick-add (event-delegated from connectedCallback) ── */
    async _fbtAddToCart(variantId, btn) {
      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = '…';

      try {
        var res = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await this.refreshSection();
        btn.textContent = '✓ Added';
        this._publishCartUpdate();
      } catch (err) {
        btn.textContent = 'Try again';
        this._showError();
      } finally {
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled = false;
        }, 2000);
      }
    }

    connectedCallback() {
      this._bindItemControls();

      this.addEventListener('click', (e) => {
        var btn = e.target.closest('[data-fbt-variant-id]');
        if (!btn) return;
        e.preventDefault();
        this._fbtAddToCart(btn.dataset.fbtVariantId, btn);
      });
    }
  }

  customElements.define('avm-cart-drawer', AvmCartDrawer);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
